import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { B as s, A as n } from "./avatar-Cf_y9mVA.mjs";
import { m as a } from "./tss-DN0acMKN.mjs";
import { L as i } from "./link-unstyled-CvXR-8s6.mjs";
import { f as m } from "./format-base-props-8NDUNDcL.mjs";
const c = a()((o) => {
  const { constructs: t, mixins: r } = o;
  return {
    root: {
      cursor: "pointer",
      textAlign: "unset",
      // browser defaults buttons to text-align: center
      textDecoration: "none",
      "&:hover, &:focus-visible": {
        borderColor: t.border.primary.medium,
        textDecoration: "none"
      },
      "&:focus-visible": {
        boxShadow: `0 0 0 4px ${r.alpha(t.surface.primary.strong, 0.1)}`
      }
    }
  };
}), f = (o) => {
  const { classes: t } = c(), { component: r = "button" } = o;
  return /* @__PURE__ */ e.jsx(
    s,
    {
      ...m(o),
      classes: t,
      component: r === "a" || o.href ? i : r,
      "data-fabric-component": "ActionTile"
    }
  );
};
f.Avatar = n;
export {
  f as A
};
//# sourceMappingURL=action-tile-DYy0A47B.mjs.map
